import { render, staticRenderFns } from "./ChatBoxModalImage.vue?vue&type=template&id=498d238c&scoped=true&"
import script from "./ChatBoxModalImage.vue?vue&type=script&lang=js&"
export * from "./ChatBoxModalImage.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxModalImage.vue?vue&type=style&index=0&id=498d238c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d238c",
  null
  
)

export default component.exports